<template>
  <div>
    <custom-header></custom-header>
    <section class="content">
      <div class="columns">
        <div class="column">
          <h1>Transactions</h1>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Status</label>
            </div>
            <div class="field-body">
              <div class="field is-narrow">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select @change="loadNew" v-model="status">
                      <option value="">all</option>
                      <option value="failed">failed</option>
                      <option value="init">init</option>
                      <option value="success">success</option>
                      <option value="pending">pending</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <trans-table :url="apiUrl"></trans-table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import url from '../utils/url'
import moment from 'moment'
import CustomHeader from '@/components/CustomHeader'
import TransTable from '../components/TransTable'

export default {
  data() {
    return {
      messageClass: 'is-loading',
      message: '',
      spinnerShow: true,
      tableData: null,
      status: this.$route.query && this.$route.query.status,
    }
  },
  computed: {
    apiUrl() {
      const base = url + '/support/';
      const fullPath = this.$route.fullPath
      return base + fullPath;
    }
  },
  components: {
    CustomHeader, TransTable
  },
  mounted() {
    // this.getTransactions('all')
  },
  methods: {
    loadNew: function() {
      const status = this.status;
      this.$router.push({ path: this.$route.path, query: { status }})
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spinner {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;

  -webkit-animation: sk-rotate 2.0s infinite linear;
  animation: sk-rotate 2.0s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #0ac97b;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg)
  }
}

@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg)
  }
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0.0)
  }
  50% {
    -webkit-transform: scale(1.0)
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// Transactions.vue?06807b3c